import { ToEntity } from 'core/common/mappers';
import { Subscription } from '../entities';
import { SubscriptionDto } from '../services/dto';

export class SubscriptionDtoMapper implements ToEntity<Subscription, SubscriptionDto> {
  toEntity(dto: SubscriptionDto): Subscription {
    return {
      extraData: dto.extra_data,
      productName: dto.product_name,
      status: dto.status,
    };
  }
}
